import { render, staticRenderFns } from "./ElementStudioElements.vue?vue&type=template&id=b1a00f54&"
import script from "./ElementStudioElements.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioElements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports